import { Controller } from "@hotwired/stimulus"
import tippy from 'tippy.js'

export default class extends Controller {
  static values = {
    text: String,
    type: {
      type: String,
      default: 'text/plain'
    },
    tooltip: String,
    copiedTooltip: String,
    copiedDuration: {
      type: Number,
      default: 2000
    }
  }

  static targets = ["defaultContent", "copiedContent", "toast"]

  connect() {
    if (this.hasTooltipValue) {
      this.initTooltip()
    }
  }

  copy(event) {
    event.preventDefault()

    const type = this.typeValue
    const blob = new Blob([this.textValue], { type })
    const text = new ClipboardItem({ [type]: blob })

    navigator.clipboard.write([text])
      .then(() => {
        if (this.tippy && this.hasCopiedTooltipValue) {
          this.tippy.setContent(this.copiedTooltipValue)
        }
        this.#swapToCopiedContent()
        this.#showToast()
      })
  }

  initTooltip() {
    this.tippy = tippy(this.element, {
      content: this.tooltipValue,
      trigger: 'mouseenter',
      placement: 'bottom',
      theme: 'light',
      delay: [300, 0],
      hideOnClick: false,
      onHidden: () => {
        this.tippy.setContent(this.tooltipValue)
      }
    })
  }

  #showToast() {
    if (!this.hasToastTarget) return

    document.getElementById("toasts")?.append(this.toastTarget.content.cloneNode(true))
  }

  #swapToCopiedContent() {
    if (!this.hasDefaultContentTarget || !this.hasCopiedContentTarget) return

    clearTimeout(this.swapTimeout)
    this.#showOnly(this.copiedContentTarget, this.defaultContentTarget)
    this.swapTimeout = setTimeout(() => {
      this.#showOnly(this.defaultContentTarget, this.copiedContentTarget)
    }, this.copiedDurationValue)
  }

  #showOnly(visible, hidden) {
    visible.classList.remove("hidden")
    visible.classList.add("inline-flex")
    hidden.classList.remove("inline-flex")
    hidden.classList.add("hidden")
  }
}
